import { MetricPeriod } from '../hooks/useRevenueMetricsContext';

export const getFormatTypeByPeriod = (period: MetricPeriod) => {
  switch (period) {
    case MetricPeriod.ONE_DAY:
      return 'MM.DD';
    case MetricPeriod.ONE_WEEK:
      return 'MM.DD';
    case MetricPeriod.ONE_MONTH:
      return 'MM월';
    default:
      return 'MM.DD';
  }
};
